var $name="systems",$path="configs/systems.js",$this={$name,$path,};const unkwnown = require('./unknown');

module.exports = {
  ...unkwnown,
  win: 'Windows',
  macos: 'macOS',
  ios: 'iOS',
  android: 'Android',
  googlebot: 'Googlebot',
};
